import * as React from "react";
import {cs} from "@Common/react/chain-services";
import "./instruction.scss";
import {Section1} from "./section1/section1";

export const Instruction = ({}) => cs(
    () => (
        <div className="instruction instruction-a9ya">
            <div className="title" xd-qa-type="label" xd-qa-name="Upload Address List Help & Support">
                Help & Support
            </div>

            <div className="content">
                {Section1({})}
            </div>
        </div>
    ),
);
